module.exports = __webpack_public_path__ + "static/media/tickmark.279eb107.svg";